import React from "react";
import BaseInput from "../../../../components/BaseInput";
import BaseButton from "../../../../components/BaseButton";
import useController from "./controller";
import BaseTextButton from "../../../../components/BaseTextButton";
import "./style.scss";
import { useTranslation } from "react-i18next";

export default function RecoveryCodeForm() {
  const {
    isSmsSending,
    smsVerified,
    onSubmitCodeHandle,
    requestCodeAgain,
    errorMessage,
    refreshTimer,
    code,
    isCodeValid,
    onCodeHandle,
  } = useController();
  const { t } = useTranslation();
  return (
    <div className="recovery-form">
      {refreshTimer === 0 ? (
        <div className="recovery-form__request-refresh-code">
          <BaseTextButton onClick={requestCodeAgain}>
            {t("recovery_page.request_new_code")}
          </BaseTextButton>
        </div>
      ) : (
        <p className="recovery-form__refresh-code">
          {t("recovery_page.refresh_code")}
          {refreshTimer}
          {t("recovery_page.sec")}
        </p>
      )}
      <div className="recovery-form__code">
        <form onSubmit={onSubmitCodeHandle}>
          <BaseInput
            id="code"
            value={code}
            onChange={onCodeHandle}
            name="code"
            type="text"
            label={t("recovery_page.code_from_lesson")}
            errorMessage={errorMessage || smsVerified}
          />
          <BaseButton
            type="submit"
            className="recovery-form__btn-next"
            loading={isSmsSending}
            disabled={isCodeValid || !code.length}
          >
            {t("next")}
          </BaseButton>
        </form>
      </div>
    </div>
  );
}
